import { render } from "./SceneSection.vue?vue&type=template&id=c8a5cf5e"
import script from "./SceneSection.vue?vue&type=script&lang=js"
export * from "./SceneSection.vue?vue&type=script&lang=js"

import "./SceneSection.vue?vue&type=style&index=0&id=c8a5cf5e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__